import styled from "styled-components"

const Title = styled.h2`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

const Description = styled.p`
  color: ${(props) => props.theme.d_color_gradients.a_dark};
`

export { Title, Description }
